// extracted by mini-css-extract-plugin
export default {"container":"HomeLayout_container__BQojl","contentWrapper":"HomeLayout_contentWrapper__2ByH4","mainAndRightArea":"HomeLayout_mainAndRightArea__BBWt7"};